import isValidBeatenThickness from "./isValidBeatenThickness"
import isValidBoard from "./isValidBoard"
import isValidBoardThickness from "./isValidBoardThickness"
import isValidBuildUpMethod from "./isValidBuildUpMethod"
import isValidEstManuFactoryId from "./isValidEstManuFactoryId"
import isValidFpcBoardThickness from "./isValidFpcBoardThickness"
import isValidHardGoldOnPCIEdgeTerminal from "./isValidHardGoldOnPCIEdgeTerminal"
import isValidImpedance from "./isValidImpedance"
import isValidLayer from "./isValidLayer"
import isValidMetalMask from "./isValidMetalMask"
import isValidMetalMaskDtl from "./isValidMetalMaskDtl"
import isValidMinLand from "./isValidMinLand"
import isValidMinPattern from "./isValidMinPattern"
import isValidResistColor from "./isValidResistColor"
import isValidResistPrint from "./isValidResistPrint"
import isValidRoulette from "./isValidRoulette"
import isValidSilk from "./isValidSilk"
import isValidSilkColor from "./isValidSilkColor"
import isValidSilkPrintMethod from "./isValidSilkPrintMethod"
import isValidSurfaceFinishing from "./isValidSurfaceFinishing"

const visibleValidator = {
  layer: isValidLayer,
  metalmask: isValidMetalMask,
  metalMaskDtl: isValidMetalMaskDtl,
  board: isValidBoard,
  boardThickness: isValidBoardThickness,
  fpcBoardThickness: isValidFpcBoardThickness,
  beatenThickness: isValidBeatenThickness,
  buildUpMethod: isValidBuildUpMethod,
  minPattern: isValidMinPattern,
  minLand: isValidMinLand,
  impedance: isValidImpedance,
  resistPrint: isValidResistPrint,
  resistColor: isValidResistColor,
  silk: isValidSilk,
  silkColor: isValidSilkColor,
  silkPrintMethod: isValidSilkPrintMethod,
  surfaceFinishing: isValidSurfaceFinishing,
  hardGoldOnPCIEdgeTerminal: isValidHardGoldOnPCIEdgeTerminal,
  roulette: isValidRoulette,
  estManuFactoryId: isValidEstManuFactoryId,
} as const

export default visibleValidator
